import { render } from "./document_patient.vue?vue&type=template&id=d8f632b8&scoped=true"
import script from "./document_patient.vue?vue&type=script&lang=js"
export * from "./document_patient.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./document_patient.vue?vue&type=style&index=1&id=d8f632b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f632b8"]])

export default __exports__